module.exports = __webpack_public_path__ + "static/media/login-signup-icon.94eb98f4.svg";